import ReclutamientoApi from "../api/reclutamientoApi";

class ReclutamientoService {
    static async createReclutamiento(reclutamientoData) {
        try {
            const response = await ReclutamientoApi.createReclutamiento(reclutamientoData);
            // La respuesta ahora incluye el ID directamente
            return response.data;
        } catch (error) {
            if (error.response) {
                console.error('Error en ReclutamientoService (respuesta):', {
                    status: error.response.status,
                    data: error.response.data,
                    headers: error.response.headers
                });
            } else if (error.request) {
                console.error('Error en ReclutamientoService (sin respuesta del servidor):', error.message);
            } else {
                console.error('Error en ReclutamientoService (configuración):', error.message);
            }
            throw error;
        }
    }

    static async uploadFile(reclutamientoId, file) {
        try {
            if (!reclutamientoId) {
                throw new Error('El ID del reclutamiento es requerido para subir archivos');
            }
            const response = await ReclutamientoApi.uploadFile(reclutamientoId, file);
            return response.data;
        } catch (error) {
            console.error('Error al subir archivo:', error);
            throw error;
        }
    }

    static async getReclutamiento(reclutamientoId) {
        try {
            const response = await ReclutamientoApi.getReclutamiento(reclutamientoId);
            return response.data;
        } catch (error) {
            console.error('Error en ReclutamientoService:', error);
            throw error;
        }
    }

    static async validateToken(token) {
        try {
            if (!token) {
                throw new Error('El token es requerido para la validación');
            }
            const response = await ReclutamientoApi.validateToken(token);
            return response.data;
        } catch (error) {
            console.error('Error al validar token:', error);
            throw error;
        }
    }

    static async invalidateToken(token) {
        try {
            if (!token) {
                throw new Error('El token es requerido para la invalidación');
            }
            const response = await ReclutamientoApi.invalidateToken(token);
            return response.data;
        } catch (error) {
            console.error('Error al invalidar token:', error);
            throw error;
        }
    }
}

export default ReclutamientoService;
